import styled from '@emotion/styled';

export const ExternalMenuLink = styled.a``;
